module.exports = __webpack_public_path__ + "img/sv9.20fadcba.svg";